
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'DetalhesVinculoPopup',
})
export default class DetalhesVinculoPopup extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) vinculo!: any;

  private chartOptionsProbabilidade = {
    chart: {
      type: 'radialBar',
      height: 200,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '70%',
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: '14px',
            offsetY: -10
          },
          value: {
            show: true,
            fontSize: '24px',
            offsetY: 5
          }
        }
      }
    },
    labels: ['Probabilidade'],
    colors: ['#FF5252']
  };

  get fatoresRisco() {
    const fatores = [
      {
        descricao: 'Faltas não justificadas',
        valor: this.vinculo.detalhes.faltas
      },
      {
        descricao: 'Advertências',
        valor: this.vinculo.detalhes.advertencias
      },
      {
        descricao: 'Férias atrasadas',
        valor: this.vinculo.detalhes.feriasAtrasadas
      },
      {
        descricao: 'Afastamentos',
        valor: this.vinculo.detalhes.afastamentos
      },
      {
        descricao: 'Movimentações gerenciais',
        valor: this.vinculo.detalhes.movimentacoesGerenciais
      },
      {
        descricao: 'Atrasos de pagamento',
        valor: this.vinculo.detalhes.atrasosDePagamentoFolha
      }
    ].filter(fator => fator.valor > 0);
    
    if (this.vinculo.detalhes.mediaHorasExtraMes > 0) {
      fatores.push({
        descricao: 'Média de horas extras por mês',
        valor: `${this.vinculo.detalhes.mediaHorasExtraMes.toFixed(1)}h`
      });
    }
    
    // Adiciona insalubridade se for true
    if (this.vinculo.detalhes.ambienteInsalubre) {
      fatores.push({
        descricao: 'Atribuição possui Insalubridade?',
        valor: 'Sim'
      });
    }
    if (this.vinculo.detalhes.periculosidade) {
      fatores.push({
        descricao: 'Atribuição possui Periculosidade?',
        valor: 'Sim'
      });
    }
    
    return fatores;
  }

  get fatoresPositivos() {
    return [
      {
        descricao: 'Promoções recebidas',
        valor: this.vinculo.detalhes.promocoes
      },
      {
        descricao: 'Reajustes salariais',
        valor: this.vinculo.detalhes.reajustes
      },
      {
        descricao: 'Férias tiradas regularmente',
        valor: this.vinculo.detalhes.feriasCompletas
      },
      {
        descricao: 'Férias programadas',
        valor: this.vinculo.detalhes.ferias
      }
    ].filter(fator => fator.valor > 0); // Mostra apenas fatores com valores positivos
  }

  private getRiscoColor(risco: string): string {
    const cores = {
      BAIXO: '#FDD835', // Amarelo
      MEDIO: '#FF9800', // Laranja
      ALTO: '#F44336', // Vermelho
    };
    return cores[risco] || 'grey';
  }

  private getRiscoIcon(risco: string): string {
    const icons = {
      BAIXO: 'mdi-alert-circle-outline',
      MEDIO: 'mdi-alert',
      ALTO: 'mdi-alert-circle',
    };
    return icons[risco] || 'mdi-help';
  }

  private getRiscoDescricao(risco: string): string {
    const descricoes = {
      BAIXO: 'Risco baixo de turnover',
      MEDIO: 'Risco médio de turnover',
      ALTO: 'Risco alto de turnover',
    };
    return descricoes[risco] || 'Nível de risco desconhecido';
  }
}
